export const GET_USERS_LOADING = 'GET_USERS_LOADING';
export const GET_USERS_COMPLETE = 'GET_USERS_COMPLETE';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const DELETE_USER_LOADING = 'DELETE_USER_LOADING';
export const DELETE_USER_COMPLETE = 'DELETE_USER_COMPLETE';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';
export const TOGGLE_CONFIRM_DELETE = 'TOGGLE_CONFIRM_DELETE';
export const FILTER_USERS = 'FILTER_USERS';
export const SORT_USERS = 'SORT_USERS';
